import React,{ useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import './RouteInfo.css';

const UnplannedItem = ({ route_id, url }) => {
    const unplannedRoute = useSelector((state) => state.unplannedRoutes.data[route_id]);

    return (
        <Link to={url}>
            <div className="item-header" style={ { fontSize:'1.8rem', flex:1, flexDirection:'column' } }>
                <div>Voertuig { unplannedRoute?.licenseplate }</div>
                <div style={ {fontSize:'1.2rem'} }>{`${new Date(unplannedRoute.createdAt).toLocaleString('nl-NL')}`}</div>
            </div>
        </Link>
    );
}

export default UnplannedItem;
